import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { AppConfig } from 'src/app/app.config';
import { AgGridColumnDefsConstants } from 'src/app/shared/constants/ag-grid-angular-constants';
import { EnvironmentConfig } from 'src/app/shared/models/environment';
import { PbmCellRendererComponent } from '../../payer/pbm-cell-renderer/pbm-cell-renderer.component';
import { MDMService } from 'src/app/mdm/mdm.service';
import { MDMCommonConstants } from '../../constants/mdm-common-constants';
import {
  PBMTableConstant,
  PayerWrapperConstants
} from 'src/app/mdm/constants/mdm-common-constants';
import { ToasterNotificationService } from 'src/app/mdm/ngx-toastr/toaster-notification.service'
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pbm',
  templateUrl: './pbm.component.html',
  styleUrls: ['./pbm.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class PbmComponent implements OnInit {
  widthList = ['MSTR_MDM_ID', 'START_DATE', 'COUNT'];
  selectedFilter = { value: 'PAYER' }
  gridOptions: object;
  defaultColDef: { [x: string]: string | boolean; };
  environment: EnvironmentConfig;
  noRowsTemplate: string;
  @Input('tableColumns') tableColumns: any;

  constructor(private config: AppConfig, private service: MDMService,
    private toaster: ToasterNotificationService
  ) {
    this.environment = this.config.getConfigObject();
  }
  sortOrder: string = MDMCommonConstants.DESC;
  sortByColumn: string;
  searchBy: string;
  showAgGridLoader: boolean;
  domLayout = "autoHeight";
  colDefs: ColDef[] = [];
  pbmRowData: any[];
  frameworkComponents: any;
  page = 1;
  pageSize: number;
  totalRecords: number;
  pbmSub: Subscription;

  ngOnInit(): void {
    this.pageSize = this.environment.pageSize;
    this.defaultColDef = {
      [AgGridColumnDefsConstants.SUPPRESS_MENU]: true,
      [AgGridColumnDefsConstants.SUPPRESS_MOVABLE]: true,
      [AgGridColumnDefsConstants.CELL_CLASS]: 'ag-cell-padding',
      [AgGridColumnDefsConstants.AUTO_HEIGHT]: true,
      [AgGridColumnDefsConstants.AUTO_HEIGHT]: true,
    };
    this.gridOptions = {
      [AgGridColumnDefsConstants.DEFAULT_COL_DEF]: this.defaultColDef,
      [AgGridColumnDefsConstants.ROW_HEIGHT]: 56,
      [AgGridColumnDefsConstants.HEADER_HEIGHT]: 56,
      defaultColDef: {
        sortable: true,
        unSortIcon: true
      },
      [AgGridColumnDefsConstants.APPLY_COLUMN_DEF_ORDER]: true,
    };
    this.frameworkComponents = {
      custumizedId: PbmCellRendererComponent,
    };
    this.setColumns();
    this.getPBMTableDetails();
  }

  getPBMTableDetails() {
    this.showAgGridLoader = true;
    if (this.pbmSub) {
      this.pbmSub.unsubscribe();
    }
    this.pbmSub = this.service.getPBMMatches(this.sortByColumn,
      this.sortOrder,
      this.searchBy,
      this.page,
      this.pageSize).subscribe((data) => {
        this.pbmRowData = data.data;
        this.totalRecords = data.totalRecords;
        this.showAgGridLoader = false;
      }, (exception) => {
        this.showAgGridLoader = false;
        this.toaster.showError(exception.error.message, '');

      })
  }
  pageChanged(event) {
    this.page = event;
    this.getPBMTableDetails();
  }

  searchPayerByChanged() {
    this.getPBMTableDetails();
  }
  clearSearch(value) {
    if (!value) {
      this.getPBMTableDetails();

    }
  }
  //sort the columns when clicked on table header
  onSort(event) {
    const columnsSortState = event.columnApi.getColumnState();
    let colId: number;
    let colName = '';
    let columnSortOrder = '';
    let i = 0;
    for (const column of columnsSortState) {
      if (column.sort) {
        colId = i + 1;
        colName = column.colId;
        columnSortOrder = column.sort;
        break;
      }
      i++;
    }
    this.sortOrder = columnSortOrder;
    this.sortByColumn = colName;
    this.getPBMTableDetails();
  }

  setColumns() {
    this.showAgGridLoader = true;
    for (const column in this.tableColumns) {
      this.colDefs.push({
        headerName: column.replace(/_/g, ' '),
        field: this.tableColumns[column],
        [AgGridColumnDefsConstants.FLEX]: 1,
        [AgGridColumnDefsConstants.HEADER_TOOLTIP]: column.replace(/_/g, ' '),
        [AgGridColumnDefsConstants.TOOLTIP_VALUE_GETTER]: this.getCellTooltip(),
        [AgGridColumnDefsConstants.MAX_WIDTH]: this.widthList.includes(this.tableColumns[column])
          ? 180 : this.tableColumns[column] === 'MSTR_PBM_NAME' ? 500
            : 250,
        sortingOrder: ['asc', 'desc'],
        ...((this.tableColumns[column] == PBMTableConstant.MDM_ID
          ? true
          : this.tableColumns[column] == PBMTableConstant.SUSPECTED_SOURCES
            ? true
            : this.tableColumns[column] == PBMTableConstant.PBM_NAME ?
              true
              : this.tableColumns[column] == PBMTableConstant.HIGHEST_MATCH_PERCENTAGE
                ? true
                : false) && { cellRenderer: PbmCellRendererComponent }),
        cellRendererParams: {
          [this.tableColumns[column]]: true,
          routerlink: '/mdm/all-records/payer/profile/',
          state: {
            entity: PayerWrapperConstants.PBM,
            return_page: 'suspected',
          },
        },
      });
    }
  }

  getCellTooltip() {
    return (cellParams) => cellParams.value;
  }
  ngOnDestroy(): void {
    this.pbmSub.unsubscribe();
  }
}
